import * as React from 'react';

/**
 * 簡単な切り替えコンポネント
 * @typedef SwitchArray
 * @type {Array}
 * @property {string} "ON"の表現
 * @property {string} "OFF"の表現
 *
 * @param {string} { label = '' } Switchの前に表示されているテキスト
 * @param {SwitchArray} { switchTextArray = ['ON', 'OFF'] } ON/OFF切り替えテキスト
 * @param {Function} { handleToggle } 切り替えファンクション
 * @param {Boolean} { checked } 切り替え状態
 * @param {Boolean} disabled input
 * @returns
 */
const Switch = ({
  label = '',
  switchTextArray = ['ON', 'OFF'],
  handleToggle,
  checked,
  disabled,
}) => {
  return (
    <div className='switch'>
      <span className='switch__label'>
        {label && <span>{label}</span>}
        {switchTextArray && (
          <span>{checked ? switchTextArray[0] : switchTextArray[1]}</span>
        )}
      </span>
      <label htmlFor='toggle-header' className='toggle'>
        <input
          type='checkbox'
          checked={checked}
          disabled={disabled}
          id='toggle-header'
          onChange={() => handleToggle()}
        />
        <div className='toggle__item' />
      </label>
    </div>
  );
};

export default Switch;



// WEBPACK FOOTER //
// ./src/components/Switch.jsx